import { safeJoin } from 'utils/StringUtil';

export const makeWidgetKey = safeJoin(':');
